
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_stzga_99",
  "header": "awsui_header_l0dv0_stzga_136",
  "header-link": "awsui_header-link_l0dv0_stzga_149",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_stzga_159",
  "header-link-text": "awsui_header-link-text_l0dv0_stzga_159",
  "header-logo": "awsui_header-logo_l0dv0_stzga_164",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_stzga_170",
  "list-container": "awsui_list-container_l0dv0_stzga_175",
  "list": "awsui_list_l0dv0_stzga_175",
  "list-variant-root": "awsui_list-variant-root_l0dv0_stzga_187",
  "list-variant-root--last": "awsui_list-variant-root--last_l0dv0_stzga_194",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_stzga_198",
  "list-item": "awsui_list-item_l0dv0_stzga_202",
  "section": "awsui_section_l0dv0_stzga_210",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_stzga_211",
  "section--no-ident": "awsui_section--no-ident_l0dv0_stzga_214",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_stzga_215",
  "refresh": "awsui_refresh_l0dv0_stzga_223",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_stzga_231",
  "section-group": "awsui_section-group_l0dv0_stzga_238",
  "section-group-title": "awsui_section-group-title_l0dv0_stzga_249",
  "link": "awsui_link_l0dv0_stzga_253",
  "link-active": "awsui_link-active_l0dv0_stzga_262",
  "info": "awsui_info_l0dv0_stzga_299",
  "external-icon": "awsui_external-icon_l0dv0_stzga_303",
  "divider": "awsui_divider_l0dv0_stzga_307",
  "divider-default": "awsui_divider-default_l0dv0_stzga_313",
  "divider-header": "awsui_divider-header_l0dv0_stzga_318"
};
  